import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SwitchComponent } from './switch.component';

@NgModule({
  imports: [CommonModule],
  exports: [SwitchComponent],
  declarations: [SwitchComponent],
  providers: [],
})
export class SwitchModule {
}
